import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import RestrictedContentOverlay from 'Component/RestrictedContentOverlay/RestrictedContentOverlay.component';
import { CustomerType } from 'Type/Account.type';

export const MyAccountDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/MyAccount/MyAccount.dispatcher'
);

/** @namespace PeggysagePwa/Component/RestrictedContentOverlay/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    customer: state.MyAccountReducer.customer
});

/** @namespace PeggysagePwa/Component/RestrictedContentOverlay/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    requestCustomerData: () => MyAccountDispatcher.then(
        ({ default: dispatcher }) => dispatcher.requestCustomerData(dispatch)
    )
});

/** @namespace PeggysagePwa/Component/RestrictedContentOverlay/Container */
export class RestrictedContentOverlayContainer extends PureComponent {
    static propTypes = {
        customer: CustomerType.isRequired,
        requestCustomerData: PropTypes.func.isRequired,
        allowedCustomerGroupIds: PropTypes.arrayOf(PropTypes.number)
    };

    static defaultProps = {
        allowedCustomerGroupIds: []
    };

    state = {
        userGroupId: 0
    };

    componentDidMount() {
        this.getCustomerGroup();
    }

    componentDidUpdate(prevProps) {
        const { customer: { group_id: groupId = 0 } = {} } = this.props;
        const { customer: { group_id: prevGroupId = 0 } = {} } = prevProps;

        if (groupId !== prevGroupId) {
            this.getCustomerGroup();
        }
    }

    getCustomerGroup() {
        const { customer: { group_id: groupId = 0 } = {} } = this.props;

        this.setState({ userGroupId: groupId });
    }

    containerProps() {
        const { allowedCustomerGroupIds } = this.props;
        const { userGroupId } = this.state;
        return {
            allowedCustomerGroupIds,
            userGroupId
        };
    }

    render() {
        return (
            <RestrictedContentOverlay
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RestrictedContentOverlayContainer);
